import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'
import { useAllowedTabs } from 'app/hooks/useAccess'

import Admin from './Admin/Admin'
import Parent from './Parent/Parent'
import Student from './Student/Student'
import Teacher from './Teacher/Teacher'

// `label` must match the tab labels registered in the permission catalogue
// (IN_PAGE_TABS.users in app/permissions.js) — that is what the ids are built
// from. 'users' is this page's menu `name` in config.js.
const MENU_NAME = 'users'

const TABS = [
  {
    id: 'student',
    label: 'Student',
    path: navigationPaths.student,
    Comp: Student
  },
  {
    id: 'parent',
    label: 'Guardians',
    path: navigationPaths.parent,
    Comp: Parent
  },
  {
    id: 'teacher',
    label: 'Teacher',
    path: navigationPaths.teacher,
    Comp: Teacher
  },
  { id: 'admin', label: 'Admin', path: navigationPaths.admin, Comp: Admin }
]

const TAB_BY_PATH = TABS.reduce(
  (acc, tab) => ({ ...acc, [tab.path]: tab.id }),
  {}
)

const Users = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const allowedTabs = useAllowedTabs(MENU_NAME, TABS)

  const pathTab = TAB_BY_PATH[pathname]
  // Fall back to the first tab the role ALLOWS, not a hard-coded 'student' — a
  // role without the Student tab would otherwise land on a tab it cannot see.
  const currentTab =
    (allowedTabs.some((tab) => tab.id === pathTab) && pathTab) ||
    allowedTabs[0]?.id

  const handleTabChange = (_, value) => {
    if (value === currentTab) return
    const next = TABS.find((tab) => tab.id === value)
    if (next) history.push(next.path)
  }

  const active = TABS.find((tab) => tab.id === currentTab)
  const RoleComponent = active?.Comp

  if (!RoleComponent) return null

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          {allowedTabs.map((tab) => (
            <Tab key={tab.id} label={tab.label} value={tab.id} />
          ))}
        </Tabs>
      </PageTabsBar>
      <RoleComponent />
    </>
  )
}

export default Users
